// Generated layout: one JSON file per feature namespace per language, under src/locales/<language>/.
// To add a language: copy src/locales/en to src/locales/<code>, translate it, import its files here and
// list the language in languages.ts. The resources test fails until every key is translated.
import en_common from '../locales/en/common.json';
import en_shared from '../locales/en/shared.json';
import en_auth from '../locales/en/auth.json';
import en_landing from '../locales/en/landing.json';
import en_dashboard from '../locales/en/dashboard.json';
import en_users from '../locales/en/users.json';
import en_department from '../locales/en/department.json';
import en_deviceUser from '../locales/en/deviceUser.json';
import en_deviceApiKey from '../locales/en/deviceApiKey.json';
import en_attendance from '../locales/en/attendance.json';
import en_shifts from '../locales/en/shifts.json';
import en_holiday from '../locales/en/holiday.json';
import en_leave from '../locales/en/leave.json';
import en_notice from '../locales/en/notice.json';
import en_task from '../locales/en/task.json';
import en_payroll from '../locales/en/payroll.json';
import en_tax from '../locales/en/tax.json';
import en_accounting from '../locales/en/accounting.json';
import en_billing from '../locales/en/billing.json';
import en_institutions from '../locales/en/institutions.json';
import en_appraisal from '../locales/en/appraisal.json';
import bn_common from '../locales/bn/common.json';
import bn_shared from '../locales/bn/shared.json';
import bn_auth from '../locales/bn/auth.json';
import bn_landing from '../locales/bn/landing.json';
import bn_dashboard from '../locales/bn/dashboard.json';
import bn_users from '../locales/bn/users.json';
import bn_department from '../locales/bn/department.json';
import bn_deviceUser from '../locales/bn/deviceUser.json';
import bn_deviceApiKey from '../locales/bn/deviceApiKey.json';
import bn_attendance from '../locales/bn/attendance.json';
import bn_shifts from '../locales/bn/shifts.json';
import bn_holiday from '../locales/bn/holiday.json';
import bn_leave from '../locales/bn/leave.json';
import bn_notice from '../locales/bn/notice.json';
import bn_task from '../locales/bn/task.json';
import bn_payroll from '../locales/bn/payroll.json';
import bn_tax from '../locales/bn/tax.json';
import bn_accounting from '../locales/bn/accounting.json';
import bn_billing from '../locales/bn/billing.json';
import bn_institutions from '../locales/bn/institutions.json';
import bn_appraisal from '../locales/bn/appraisal.json';

export const NAMESPACES = ['common', 'shared', 'auth', 'landing', 'dashboard', 'users', 'department', 'deviceUser', 'deviceApiKey', 'attendance', 'shifts', 'holiday', 'leave', 'notice', 'task', 'payroll', 'tax', 'accounting', 'billing', 'institutions', 'appraisal'] as const;
export type Namespace = typeof NAMESPACES[number];

export const defaultNS = 'common';

export const resources = {
    en: {
        common: en_common,
        shared: en_shared,
        auth: en_auth,
        landing: en_landing,
        dashboard: en_dashboard,
        users: en_users,
        department: en_department,
        deviceUser: en_deviceUser,
        deviceApiKey: en_deviceApiKey,
        attendance: en_attendance,
        shifts: en_shifts,
        holiday: en_holiday,
        leave: en_leave,
        notice: en_notice,
        task: en_task,
        payroll: en_payroll,
        tax: en_tax,
        accounting: en_accounting,
        billing: en_billing,
        institutions: en_institutions,
        appraisal: en_appraisal,
    },
    bn: {
        common: bn_common,
        shared: bn_shared,
        auth: bn_auth,
        landing: bn_landing,
        dashboard: bn_dashboard,
        users: bn_users,
        department: bn_department,
        deviceUser: bn_deviceUser,
        deviceApiKey: bn_deviceApiKey,
        attendance: bn_attendance,
        shifts: bn_shifts,
        holiday: bn_holiday,
        leave: bn_leave,
        notice: bn_notice,
        task: bn_task,
        payroll: bn_payroll,
        tax: bn_tax,
        accounting: bn_accounting,
        billing: bn_billing,
        institutions: bn_institutions,
        appraisal: bn_appraisal,
    },
} as const;
